// extracted by mini-css-extract-plugin
module.exports = {"background":"Modal_background__3v5bl","fadein":"Modal_fadein__24NBJ"};